module.exports = __webpack_public_path__ + "static/media/3.6928739d.svg";